module.exports = __webpack_public_path__ + "static/media/az-4.18d41231.jpg";